// Configuración de MSAL para Microsoft Entra (Azure AD)
export const msalConfig = {
  auth: {
    clientId: "ff04fa26-8430-4f3a-be04-1607751afe0c",
    authority: "https://login.microsoftonline.com/2b334cd1-6a14-4f24-9edb-9df51e345f80",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true, // Necesario para navegadores como Safari
  }
};

// Ámbitos necesarios para la autenticación
export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
  redirectUri: window.location.origin
};

// Ámbitos para el token de acceso
export const tokenRequest = {
  scopes: ["User.Read", "email", "profile"]
};
